import * as momentTz from 'moment-timezone';
import {forwardRef, Inject, Injectable} from '@angular/core';
import {DayType, DBStatus, ServerConfiguration, Unit, UnitType, UsagerRole,} from '../model/common.model';
import {UserInfo} from "../model/UserInfo";
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {UnitManager} from '../model/UnitManager';
import {JobInfoManager} from '../model/JobInfoManager';
import {PlanningManager} from '../model/PlanningManager';
import {AvailabilityManager} from '../model/AvailabilityManager';
import {EmployeeScheduleManager} from '../model/EmployeeScheduleManager';
import {JSonSerializer} from '../model/JSonSerializer';
import {TimesheetManager} from '../model/TimesheetManager';
import {WeeklyWorkshiftComponentManager} from '../model/WeeklyWorkshiftComponentManager';
import {JobUnitAndEmployeeManager} from "../model/JobUnitAndEmployeeManager";
import * as moment from 'moment';

import {TranslateService} from "@ngx-translate/core";
import {DOCUMENT} from "@angular/common";
import {Router} from "@angular/router";
import {PrefName} from "../model/Preferences";
import {TzInfo} from "../model/TzInfo";
import {EstablishmentProgress} from "../home/establishment/EstablishmentProgress";
import {SearchResultEmployeeAggregation} from "../model/employee.model";
import {AlertService} from "./alert.service";
import {DomSanitizer} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {BonusAggregation} from "../home/bonus/model/BonusAggregation";
import {Utils} from "../model/Utils";

@Injectable()
export class SessionService {
    public _unitManager: UnitManager;

    // public employees: EmployeeAndWage[];
    public jobUnitAndEmployeeManager: JobUnitAndEmployeeManager;
    public jobManager: JobInfoManager;
    public planningManager: PlanningManager;

    public availabilityManager: AvailabilityManager;

    public otherScheduleManager: EmployeeScheduleManager;
    public scheduleManager: EmployeeScheduleManager;

    public weeklyWorkshiftManager = new WeeklyWorkshiftComponentManager();
    // public weeklyWorkshiftManager = new WeeklyWorkshiftManager();
    public timesheetManager = new TimesheetManager(); // Manager used when going from dashboard and the selected ts to the /home/timesheets
    public selectedTimesheetManager = new TimesheetManager(); // Manager used when going from dashboard and the selected ts to the /home/timesheets

    //public selectedEmployee: DashboardEmployeeAggregation;


    private _lastSearchOfEmployees = new Array<SearchResultEmployeeAggregation>();

    public sharedParams = {employeeId: '', refDate: moment().toDate(), unitId: '', jobId: ''};

    private _uiConfiguration = null;
    private _userinfo = null;
    private _sessionTz = null;
    private _xsrfToken = null;
    private _hideAmountTemporary = false;
    private _hideAMPMTemporary = false;

    private _homePath: string;

    private _canDeleteEmployee = false;

    private _bonusAggregation: BonusAggregation;

    private _chatServiceIsInitialized = false;

    private _searchManager = new Map<string,any>();

  private _halfGodSearchEmployee = new Array<string>();


  private _expenseIds = new Array();

    public constructor(

                       @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
                       @Inject(forwardRef(() => DomSanitizer)) protected domSanitizer: DomSanitizer,
                       @Inject(forwardRef(() => LocalStorageService)) private localStorage: LocalStorageService,
                       @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
                       @Inject(forwardRef(() => Router)) private router: Router,
                       @Inject(forwardRef(() => SessionStorageService)) private sessionStorage: SessionStorageService,
                       @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
                       @Inject(DOCUMENT) private _document: any) {
        //console.log('Creating SessionService');
    }


    public get storeSession(){
      if (this.serverConfiguration){
        return this.serverConfiguration.storeSession;
      }else{
        return false;
      }
    }

    public get expenseIds(){
      return this._expenseIds;
    }

    public storeSearch(searchType: string,objects: any){
      this._searchManager.set(searchType,objects);
    }

    public hasSearchType(searchType: string){
      if (this._searchManager.has(searchType)){
        return true;
      }
      return false;
    }

    public retrieveSearch(searchType:string){
      return this._searchManager.get(searchType);
    }

    public addToHalfGodSearchEmployee(searchString: string){
      if (this._halfGodSearchEmployee.indexOf(searchString)===-1){
        this._halfGodSearchEmployee.push(searchString);
      }
    }


    get halfGodSearchEmployee() {
      return this._halfGodSearchEmployee;
    }


    public get chatServiceIsInitialized(){
      return this._chatServiceIsInitialized;
    }
    public set chatServiceIsInitialized(b){
      this._chatServiceIsInitialized = b;
    }


  _tokenRenewedOn: Date;

  public setTokenRenewed(){
    this._tokenRenewedOn = moment().toDate();
  }

  public get shouldRenewToken():boolean{
      if (Utils.isNullOrUndefined(this._tokenRenewedOn)){
        console.log('Token renewal date is null');
        return true;
      }
      if (Utils.diffDateInMinutes(this._tokenRenewedOn,moment().toDate())>=30){
        return true;
      }else{
        console.log('Chat Token Last Renewed: ' + this._tokenRenewedOn);
      }
    return false;
  }

    public get canDeleteEmployee(){
      if (this._canDeleteEmployee === false){
        if (true === this.userInfo.user.canDeleteEmployee){
          return true;
        }
      }else{
        return true;
      }
      return false;
    }

    public get xsrfToken(){
    if (this.storeSession){
      return this.sessionStorage.retrieve('xsrfToken');
    }else{
      if (!Utils.isNullOrUndefined(this._xsrfToken)){
        return this._xsrfToken;
      }else{
        return 'NO-XSRF';
      }
    }
    }

    public set xsrfToken(s: string){
      if (this.storeSession){
        this.sessionStorage.store('xsrfToken', s);
      }else{
        this._xsrfToken = s;
      }
    }

    public get bonusAggregation(){
      return this._bonusAggregation;
    }

    public set bonusAggregation(b:BonusAggregation){
      this._bonusAggregation = b;
    }

    public get homePath(){
      return this._homePath;
    }

    public set homePath(s: string){
      this._homePath = s;
    }


    public get lastSearchOfEmployees(){
      return this._lastSearchOfEmployees;
    }

    public clearLastSearchOfEmployee(){
      this._lastSearchOfEmployees = new Array<SearchResultEmployeeAggregation>();
    }


    public storeUserName(username: string) {
      this.localStorage.store('username', username);
    }

    public getStoredUserName(): string {
      return this.localStorage.retrieve('username');
    }

  public clearStoredUserName() {
    this.localStorage.clear('username');
  }


  public storeLocale(locale: string) {
    this.localStorage.store('locale', locale);
  }

  public getStoredLocale(): string {
    return this.localStorage.retrieve('locale');
  }

  public get hasAtLeastOneEnterpriseAllowPayStub():boolean{

      for (const e of this.userInfo.enterprises){
//        console.log('checking ' + e.name + ' ' + e.allowPayStub);
        if (DBStatus.ACTIVE === e.allowPayStub){
          return true;
        }
      }

      return false;
  }


  public get hasAtLeastOneEnterpriseUsesSegment():boolean{

    for (const e of this.userInfo.enterprises){
//        console.log('checking ' + e.name + ' ' + e.allowPayStub);
      if (e.usesJobSegment ===true){
        return true;
      }
    }

    return false;
  }


  public get hasAtLeastOneEnterpriseAllowImportingTaxInformation():boolean{

    for (const e of this.userInfo.enterprises){
//        console.log('checking ' + e.name + ' ' + e.allowPayStub);
      if (DBStatus.ACTIVE === e.allowPayStub){
        return true;
      }
    }

    return false;
  }



  public get hasAtLeastOneEnterpriseHasApiConfigured():boolean{

    for (const e of this.userInfo.enterprises){
      if (e.apiConfigured()){
        return true;
      }
    }

    return false;
  }


  public get hasAtLeastOneEnterpriseHasOdooConfigured():boolean{

    for (const e of this.userInfo.enterprises){
      if (e.odooConfigured()){
        return true;
      }
    }

    return false;
  }

  public get hasAtLeastOneEnterpriseHasSageIntacctConfigured():boolean{

    for (const e of this.userInfo.enterprises){
      if (e.sageIntacctConfigured()){
        return true;
      }
    }

    return false;
  }

  public get hasAtLeastOneEnterpriseHasFolksConfigured():boolean{

    for (const e of this.userInfo.enterprises){
      if (e.folksConfigured()){
        return true;
      }
    }

    return false;
  }



  public clearStoredLocale() {
    this.localStorage.clear('locale');
  }
  /*
  get userInfo(): UserInfo {
        const serializer = new JSonSerializer();
        const ui = new UserInfo();
        const read = this.sessionStorage.retrieve('userInfo');
        // console.log('Reload from Session Storage ' + JSON.stringify(read));
        serializer.deserialize(read, ui);
        // console.log('Retrieved UserInfo from Storage: ' + JSON.stringify(this.sessionStorage.retrieve('userInfo'), null, 2));
        // console.log('Preferences! UserInfo: ' + JSON.stringify(ui.prefs, null, 2));

        return ui;
   }
   */

  get userInfo(): UserInfo {
    if (this.storeSession){
      if (Utils.isNullOrUndefined(this._userinfo)){
        console.log('this._userInfo is null. building it.');
        const serializer = new JSonSerializer();
        this._userinfo = new UserInfo();
        const read = this.sessionStorage.retrieve('userInfo');
        if (!Utils.isNullOrUndefined(read)){
          serializer.deserialize(read, this._userinfo);
          moment.locale(this.translate.instant('LanguageCode'));
          this.verifyTimeZone();
        }else{
          console.log('read info is null');
          this.close();
          this.router.navigate(['/']);
        }
      }else{
        // console.log('this._userInfo is not null' + JSON.stringify(this._userinfo,null,1));
        //console.log('this._userInfo is not null');
      }
    }else{
         if (Utils.isNullOrUndefined(this._userinfo)){
           console.log('UserInfo is null');
           this.close();
           this.router.navigate(['/']);
         }
    }
    return this._userinfo;
  }

  formatDateAsHour(date: Date):string{
    if (date){
        return this.formatMomentAsHour(moment(date));
    }
    return '';
  }

  formatMomentAsHour(mmt: moment.Moment):string{
    if (mmt){
      let res = mmt.format('LT');
      if (this.userInfo.isAMPM()){
        if (this.hideAMPMTemporary){
          res = mmt.format('hh:mm');
        }else{
          res = mmt.format('hh:mm A');
        }
      }else{
        res = mmt.format('HH:mm');  // Needed to support en speaking + Hour format 24h
      }
      return res;
    }
    return '';
  }

  get availableTz(): TzInfo[]{
    return this.userInfo.availableTz;
  }

  verifyTimeZone(){
    this.verifyTimeZoneWithId(this.userInfo.TimeZone);
  }

  verifyTimeZoneWithId(tz: string){
    this._sessionTz = tz;
    console.log('verifyTimeZoneWithId: ' + this._sessionTz);
    momentTz.tz.setDefault(this._sessionTz);
    // this.userInfo.getTimeZone()
  }

  public get sessionTz(){
    return this._sessionTz;
  }

  set userInfo( bean: UserInfo) {
      if (this.storeSession){
        const serializer = new JSonSerializer();
        const toStore = serializer.prepareForJson(bean);
        // console.log('Storing in Session Storage ' + JSON.stringify(toStore));
        this.sessionStorage.store('userInfo', toStore);
        this._userinfo = null;
      }else{
        this._userinfo = bean;
      }
    }
  /*
  set uiConfiguration( bean: UIConfiguration) {
    const serializer = new JSonSerializer();
    const toStore = serializer.prepareForJson(bean);
    // console.log('Storing in Session Storage ' + JSON.stringify(toStore));
    this.sessionStorage.store('uiConfiguration', toStore);
    this._uiConfiguration = null;
  }

  get uiConfiguration(): UIConfiguration {
    if (Utils.isNullOrUndefined(this._uiConfiguration)){
      console.log('this._uiConfiguration is null. building it.');
      const serializer = new JSonSerializer();
      this._uiConfiguration = new UIConfiguration(this.alertService,this.domSanitizer,this.modalService,this.translate);
      const read = this.sessionStorage.retrieve('uiConfiguration');
      if (!Utils.isNullOrUndefined(read)){
        serializer.deserialize(read, this._uiConfiguration);
      }else{
        console.log('cant read uiConfiguration.');
        this.close();
        this.router.navigate(['/']);
      }
    }else{
      // console.log('this._userInfo is not null' + JSON.stringify(this._userinfo,null,1));
      //console.log('this._userInfo is not null');
    }
    return this._uiConfiguration;
  }
  */


  /*
  set webClientConfigurationAggregation( bean: WebClientConfigurationAggregation) {
    const serializer = new JSonSerializer();
    const toStore = serializer.prepareForJson(bean);
    // console.log('Storing in Session Storage ' + JSON.stringify(toStore));
    this.sessionStorage.store('webClientConfigurationAggregation', toStore);
    this._webClientConfigurationAggregation = null;
  }


  get webClientConfigurationAggregation(): WebClientConfigurationAggregation {
    if (Utils.isNullOrUndefined(this._webClientConfigurationAggregation)){
      console.log('this._webClientConfigurationAggregation is null. building it.');
      const serializer = new JSonSerializer();
      this._webClientConfigurationAggregation = new WebClientConfigurationAggregation();
      const read = this.sessionStorage.retrieve('webClientConfigurationAggregation');
      if (!Utils.isNullOrUndefined(read)){
        serializer.deserialize(read, this._webClientConfigurationAggregation);
      }else{
        console.log('cant read webClientConfigurationAggregation.');
        this.close();
        this.router.navigate(['/']);
      }
    }else{
      // console.log('this._userInfo is not null' + JSON.stringify(this._userinfo,null,1));
      //console.log('this._userInfo is not null');
    }
    return this._webClientConfigurationAggregation;
  }
  */


  public changeLanguage(){
    const localeFromSession = this.userInfo.locale;
    console.log('ChangeLanguage ' + localeFromSession);
    this.translate.use(localeFromSession);
    moment.locale(this.translate.instant('LanguageCode'));
    console.log('ChangeLanguage Language: ' + this.translate.instant('LanguageDescription')  + ', ' + this.translate.instant('LanguageCode') + ' moment: ' + moment().locale());
    const currencySymbol = this.translate.instant('CurrencySymbol');
    if ('fr-ca' === moment().locale()){
      this._document.documentElement.lang = 'fr';
    }else if ('fr-fr' === moment().locale()){
      this._document.documentElement.lang = 'fr';
    }else{
      this._document.documentElement.lang = 'en';
    }
    if ('en-us' === moment().locale()){
    }

  }

  public isFrench(){
    const localeFromSession = this.userInfo.locale;
    // console.log('isFrench ' + localeFromSession);
    if ('fr-CA' === localeFromSession){
      return true;
    }
    return false;
  }


  public isEnglish(){
    const localeFromSession = this.userInfo.locale;
    // console.log('isFrench ' + localeFromSession);
    if ('en-CA' === localeFromSession){
      return true;
    }
    return false;
  }


  /**
   * If false then the amounts will be hidden by default.
   */
  public displayAmountByDefault(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.DISPLAY_AMOUNT))){
      return this.userInfo.getPref(PrefName.DISPLAY_AMOUNT).asBoolean();
    }
    return true;
  }

  public displayHelpIfAvailable(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.SHOW_HELP_WHEN_AVAILABLE))){
      return this.userInfo.getPref(PrefName.SHOW_HELP_WHEN_AVAILABLE).asBoolean();
    }
    return true;
  }

  public smartSearch(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.SMART_SEARCH))){
      return this.userInfo.getPref(PrefName.SMART_SEARCH).asBoolean();
    }
    return true;
  }

  public editInPlace(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.EDIT_IN_PLACE))){
      return this.userInfo.getPref(PrefName.EDIT_IN_PLACE).asBoolean();
    }
    return true;
  }


  public copyOnlyScheduleWithDnd(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.COPY_ONLY_SCHEDULE_WITH_DND))){
      return this.userInfo.getPref(PrefName.COPY_ONLY_SCHEDULE_WITH_DND).asBoolean();
    }
    return true;
  }



  public hideScheduleValidationPanel(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.HIDE_SCHEDULE_VALIDATION_PANEL))){
      return this.userInfo.getPref(PrefName.HIDE_SCHEDULE_VALIDATION_PANEL).asBoolean();
    }
    return false;
  }

  public hidePlanValidationPanel(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.HIDE_PLAN_VALIDATION_PANEL))){
      return this.userInfo.getPref(PrefName.HIDE_PLAN_VALIDATION_PANEL).asBoolean();
    }
    return false;
  }

  public hideLateArrivalPanel(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.HIDE_LATE_ARRIVAL_PANEL))){
      return this.userInfo.getPref(PrefName.HIDE_LATE_ARRIVAL_PANEL).asBoolean();
    }
    return false;
  }

  public hideTimesheetPanel(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.HIDE_TIMESHEET_PANEL))){
      return this.userInfo.getPref(PrefName.HIDE_TIMESHEET_PANEL).asBoolean();
    }
    return false;
  }

  public hideExpensePanel(){
    if (this.userInfo.hasExpenseModule){
      if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.HIDE_EXPENSE_PANEL))){
        return this.userInfo.getPref(PrefName.HIDE_EXPENSE_PANEL).asBoolean();
      }
      return false;
    }else{
      return true;
    }

  }

  public hideBirthdaysValidationPanel(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.HIDE_BIRTHDAYS_VALIDATION_PANEL))){
      return this.userInfo.getPref(PrefName.HIDE_BIRTHDAYS_VALIDATION_PANEL).asBoolean();
    }
    return false;
  }



  public hideSkillsValidationPanel(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.HIDE_SKILLS_VALIDATION_PANEL))){
      return this.userInfo.getPref(PrefName.HIDE_SKILLS_VALIDATION_PANEL).asBoolean();
    }
    return false;
  }


  public get useTimedTasks(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_TIMED_TASKS))){
      return this.userInfo.getPref(PrefName.USE_TIMED_TASKS).asBoolean();
    }
    return false;
  }

  public get useAPIAccess(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_API_ACCESS))){
      return this.userInfo.getPref(PrefName.USE_API_ACCESS).asBoolean();
    }
    return false;
  }

  public get useIntuitAPI(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_INTUIT_API))){
      return this.userInfo.getPref(PrefName.USE_INTUIT_API).asBoolean();
    }
    return false;
  }


  public get hideInformationForDemos(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.PREFS_HIDE_INFORMATION_FOR_DEMOS))){
      return this.userInfo.getPref(PrefName.PREFS_HIDE_INFORMATION_FOR_DEMOS).asBoolean();
    }
    return false;
  }


  public get manualValidationSchedule(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.MANUAL_VALIDATION_SCHEDULE))){
      return this.userInfo.getPref(PrefName.MANUAL_VALIDATION_SCHEDULE).asBoolean();
    }
    return false;
  }

  public get canModifyAllPastTS(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.CAN_MODIFY_ALL_PAST_TS))){
      return this.userInfo.getPref(PrefName.CAN_MODIFY_ALL_PAST_TS).asBoolean();
    }
    return false;
  }

  public get canModifyAllPastSchedules(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.CAN_MODIFY_ALL_PAST_SCHEDULES))){
      return this.userInfo.getPref(PrefName.CAN_MODIFY_ALL_PAST_SCHEDULES).asBoolean();
    }
    return false;
  }



  public get accountCanAddTestPunches(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.ACCOUNT_CAN_ADD_TEST_PUNCH))){
      return this.userInfo.getPref(PrefName.ACCOUNT_CAN_ADD_TEST_PUNCH).asBoolean();
    }
    return false;
  }

  public get accountCanDeleteTimesheetsInBatch(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.ACCOUNT_CAN_DELETE_UNAPPROVED_TS_IN_BATCH))){
      return this.userInfo.getPref(PrefName.ACCOUNT_CAN_DELETE_UNAPPROVED_TS_IN_BATCH).asBoolean();
    }
    return false;
  }



  public get autoSaveSchedules(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.AUTO_SAVE_SCHEDULES))){
      return this.userInfo.getPref(PrefName.AUTO_SAVE_SCHEDULES).asBoolean();
    }
    return false;


  }


  public get canReadConfigurationAPIV2(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.CAN_READ_CONFIGURATION_API_V2))){
      return this.userInfo.getPref(PrefName.CAN_READ_CONFIGURATION_API_V2).asBoolean();
    }
    return false;
  }

  PREFS_CAN_READ_CONFIGURATION_API_V2



  public hideInformation(prefix:string, informationToHide: string): string{
    if (this.hideInformationForDemos){
        if (informationToHide.length>0){
          if (prefix.length>0){
            return prefix + ' ' + informationToHide.charAt(0);
          }else{
            return informationToHide.charAt(0);
          }
        }
    }
    return informationToHide;
  }






  public get hasProVersion(){
    if (this.isSysAdmin()){
      return true;
    }
    const res = this.userInfo.hasProVersion;
    // console.log(this.userInfo.fullName + ' has access to PRO Version ? ' + res );
    return res;
  }

  public get hasScheduleModule(){
    if (this.isSysAdmin()){
      return true;
    }
    return this.userInfo.hasScheduleModule;
  }

  public get performanceModuleExpirationDate(){
    return this.userInfo.performanceModuleExpirationDate;
  }
  public get performanceModuleExpirationDaysLeft(){
    // console.log('Days left for the performance' + this.userInfo.performanceModuleExpirationDaysLeft);
    return this.userInfo.performanceModuleExpirationDaysLeft;
  }



  public get hasPerformanceModule(){
    if (this.isSysAdmin()){
      return true;
    }
    return this.userInfo.hasPerformanceModule;
  }

  public get hasNoPerformanceInItsModules(){
    if (this.isSysAdmin()){
      return true;
    }
    return this.userInfo.hasNoPerformanceInItsModules;
  }



  public get hasPayModule(){
    if (this.isSysAdmin()){
      return true;
    }
    return this.userInfo.hasPayModule;
  }

  public get hasTimesheetModule(){
    if (this.isSysAdmin()){
      return true;
    }
    return this.userInfo.hasTimesheetModule;
  }

  public get hasCustomGroupeCarbur(){
    if (this.isSysAdmin()){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.CUSTOM_GROUP_CARBUR))){
      return this.userInfo.getPref(PrefName.CUSTOM_GROUP_CARBUR).asBoolean();
    }
  }

  public get hasImportSchedulesFromOnTrack(){
    if (this.isSysAdmin()){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.IMPORT_SCHEDULES_FROM_ON_TRACK))){
      return this.userInfo.getPref(PrefName.IMPORT_SCHEDULES_FROM_ON_TRACK).asBoolean();
    }
  }

  public get hasExpensesModule(){
    if (this.isSysAdmin()){
      return true;
    }
    return this.userInfo.hasExpenseModule;
  }

  public get hasHRModule(){
    if (this.isSysAdmin()){
      return true;
    }
    return this.userInfo.hasHRModule;
  }


  public get hasHRConfiguration(){
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo.hrConfigAggregation){
      return true;
    }
    return false;
  }



  public showCCQOption(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.SHOW_CCQ_OPTION))){
      return this.userInfo.getPref(PrefName.SHOW_CCQ_OPTION).asBoolean();
    }
    return true;
  }


  public useGeoFence(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_GEO_FENCE))){
      return this.userInfo.getPref(PrefName.USE_GEO_FENCE).asBoolean();
    }
    return true;
  }


  public useBankType(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_BANK_TYPE))){
      return this.userInfo.getPref(PrefName.USE_BANK_TYPE).asBoolean();
    }
    return true;
  }





  public useUDataService(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_UDATA_SERVICE))){
      return this.userInfo.getPref(PrefName.USE_UDATA_SERVICE).asBoolean();
    }
    return false;
  }


  public useRetailNextService(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_RETAIL_NEXT_SERVICE))){
      return this.userInfo.getPref(PrefName.USE_RETAIL_NEXT_SERVICE).asBoolean();
    }
    return false;
  }


  public useAllieRH(){
    /**
     * Alex, Sept 21st 2026.
     */
    return this.hasAtLeastOneEnterpriseHasFolksConfigured;
    /*
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_ALLIERH_SERVICE))){
      return this.userInfo.getPref(PrefName.USE_ALLIERH_SERVICE).asBoolean();
    }
    return false;
    
     */
  }

  public useShiftBonus(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_SHIFT_BONUS))){
      return this.userInfo.getPref(PrefName.USE_SHIFT_BONUS).asBoolean();
    }
    return false;
  }


  public useCustomPremium(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_CUSTOM_PREMIUM))){
      return this.userInfo.getPref(PrefName.USE_CUSTOM_PREMIUM).asBoolean();
    }
    return false;
  }

  public canModifyCostDistribution(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.CAN_MODIFY_COST_DISTRIBUTION))){
      return this.userInfo.getPref(PrefName.CAN_MODIFY_COST_DISTRIBUTION).asBoolean();
    }
    return false;
  }

  public useReportToEmail(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_REPORT_TO_EMAIL))){
      return this.userInfo.getPref(PrefName.USE_REPORT_TO_EMAIL).asBoolean();
    }
    return false;
  }


  public canModifyCustomReport(){
    if (!Utils.isNullOrUndefined(this.userInfo.user.canModifyCustomReport)){
      return this.userInfo.user.canModifyCustomReport;
    }
    return false;
  }


  public useSyncAPI(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_SYNC_API))){
      return this.userInfo.getPref(PrefName.USE_SYNC_API).asBoolean();
    }
    return false;
  }


  public useSurveys(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_SURVEYS))){
      return this.userInfo.getPref(PrefName.USE_SURVEYS).asBoolean();
    }
    return false;
  }

  public useSurveysExtra(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.USE_SURVEYS_EXTRA))){
      return this.userInfo.getPref(PrefName.USE_SURVEYS_EXTRA).asBoolean();
    }
    return false;
  }


  public isAccountEstablished(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.ESTABLISHMENT_DONE))){
      return this.userInfo.getPref(PrefName.ESTABLISHMENT_DONE).asBoolean();
    }
    return true;
  }

  public includeVacationInAmountWhenAvailable(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.INCLUDE_VACATION_IN_AMOUNT_WHEN_AVAILABLE))){
      return this.userInfo.getPref(PrefName.INCLUDE_VACATION_IN_AMOUNT_WHEN_AVAILABLE).asBoolean();
    }
    return false;
  }

  public displaySchedulesToFill(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.DISPLAY_SCHEDULE_TO_FILL))){
      return this.userInfo.getPref(PrefName.DISPLAY_SCHEDULE_TO_FILL).asBoolean();
    }
    return false;
  }

  public displayRequestList(){

    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.DISPLAY_REQUEST_LIST))){
      return this.userInfo.getPref(PrefName.DISPLAY_REQUEST_LIST).asBoolean();
    }
    return false;
  }

  public displayMemosByType(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.DISPLAY_MEMOS_BY_TYPE))){
      return this.userInfo.getPref(PrefName.DISPLAY_MEMOS_BY_TYPE).asBoolean();
    }
    return false;
  }


  public displayDaySalesCostObjective(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.DISPLAY_DAY_SALES_COST_OBJECTIVE))){
      return this.userInfo.getPref(PrefName.DISPLAY_DAY_SALES_COST_OBJECTIVE).asBoolean();
    }
    return false;
  }

  public displayEmployeeProfileImage(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.DISPLAY_EMPLOYEE_PROFILE_IMAGE))){
      return this.userInfo.getPref(PrefName.DISPLAY_EMPLOYEE_PROFILE_IMAGE).asBoolean();
    }
    return false;
  }

  public displayPlanInSchedulePerPosition(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.DISPLAY_PLAN_IN_SCHEDULE_PER_POSITION))){
      return this.userInfo.getPref(PrefName.DISPLAY_PLAN_IN_SCHEDULE_PER_POSITION).asBoolean();
    }
    return false;
  }


  public maxHeightMenu600(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.MAX_MENU_600))){
      return this.userInfo.getPref(PrefName.MAX_MENU_600).asBoolean();
    }
    return false;
  }



  public maxHeightMenu800(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.MAX_MENU_800))){
      return this.userInfo.getPref(PrefName.MAX_MENU_800).asBoolean();
    }
    return false;
  }


  public maxHeightMenu900(){
    if (!Utils.isNullOrUndefined(this.userInfo.getPref(PrefName.MAX_MENU_900))){
      return this.userInfo.getPref(PrefName.MAX_MENU_900).asBoolean();
    }
    return false;
  }

  public get establishment() : EstablishmentProgress{
      return this.userInfo.establishment;
  }


    get serverConfiguration(): ServerConfiguration{
        return this.sessionStorage.retrieve('serverConfiguration');
    }

    set serverConfiguration( bean: ServerConfiguration ){
        this.sessionStorage.store('serverConfiguration', bean);
    }

    get inTestMode(): boolean {
      const config = this.serverConfiguration;
      if (config){
        return config.testMode;
      }
      return false;
    }

  //
  // get inAlternateUIMode(): boolean {
  //   const config = this.serverConfiguration;
  //   if (config){
  //     return config.alternateUIMode;
  //   }
  //   return false;
  // }

  get inDataTest(): boolean {
    const config = this.serverConfiguration;
    if (config){
      return config.dataTest;
    }
    return false;
  }

    //
    // set unitManager( bean: UnitManager ) {
    //   this.sessionStorage.store('unitManager', bean);
    // }
    //
     get unitManager(): UnitManager {
       if ( this._unitManager ) {
         return this._unitManager;
       }else {
  //       console.log('Creating UnitManager');
         this._unitManager = new UnitManager();
         for (const b of this.userInfo.units) {
//           console.log('Adding ' + b.unitCode + ' ' + b.parentCode + ' ' + b.description);
           this._unitManager.add(b);
         }
         return this._unitManager;
       }
     }

    displayDivisionIfMoreThanOneAsString(unit: Unit): string{
      if (!Utils.isNullOrUndefined(this._unitManager) && this._unitManager.getOrderedUnitByType(UnitType.DIVISION.code).length<=1){
        return '';
      }else{
        return ' ( ' + this.getDivisionName(unit) + ' ) ';
      }
    }

    hasMoreThanOneDivision(): boolean{
      if (!Utils.isNullOrUndefined(this._unitManager) && this._unitManager.getOrderedUnitByType(UnitType.DIVISION.code).length>1){
        return true;
      }
      return false;
    }

   hasRightsOnUnit(unitCode: string):boolean{
      if (!Utils.isNullOrUndefined(this._unitManager)){
        return this._unitManager.hasRightsOnUnit(unitCode);
      }
      return false;
    }

    getDivisionName(unit: Unit):string{
       // console.log('division for ' + unit.rootCode + ' ' + unit.description);
      if (Utils.isNullOrUndefined(unit.rootCode)){
        return unit.description;
      }else{
          return this.getUnitName(unit.rootCode);
      }
    }

    getUnitName(code: string):string{
      let res = '';
      if (!Utils.isNullOrUndefined(this._unitManager)){
        const unit = this._unitManager.getUnitByCode(code);
        if (!Utils.isNullOrUndefined(unit)){
          res = unit.description;
        }
      }
      if (res.length===0){
        for (const unit of this.userInfo.units){
          if (unit.unitCode === code){
            res = unit.description;
          }
        }
      }

      return res;
    }



  close(navigateToOrigin?:boolean) {
        this._unitManager = null; // stuck in memory ???
        this._userinfo =null;
        this.sessionStorage.clear('userInfo');
        this.sessionStorage.clear('serverConfiguration');
        this.sessionStorage.clear('xsrfToken');
        this.sessionStorage.clear();
        this._chatServiceIsInitialized = false;
        if (navigateToOrigin && navigateToOrigin === true){
          this.router.navigate(['/']);
        }
    }

    isRoleSame(role: UsagerRole): boolean{
      if (this.userInfo){
        if (this.userInfo.user){
          if (role === this.userInfo.user.userRole){
            return true;
          }
        }
      }
      return false;
    }

    isRoleSameOrGreater(role: UsagerRole): boolean{
      if (this.userInfo){
        if (this.userInfo.user){
          if (role.level<= this.userInfo.user.userRole.level){
            return true;
          }
        }
      }
      return false;
    }



  isRoleSameOrLess(role: UsagerRole): boolean{
    if (this.userInfo){
      if (this.userInfo.user){
        if (role.level>= this.userInfo.user.userRole.level){
          return true;
        }
      }
    }
    return false;
  }


  isRoleGreater(role: UsagerRole): boolean{
      if (this.userInfo){
        if (this.userInfo.user){
          if (role.level< this.userInfo.user.userRole.level){
            // console.log('isRoleGreater ' + role.level + ' currentUser: ' + this.userInfo.user.userRole.level);
            return true;
          }
        }
      }
      return false;
    }



  /**
     * Otherwise not working from HTML directly
     */
    isSameOrGreaterThan_EXECUTIVE_LIMITED_ADMIN(): boolean{
      return this.isRoleSameOrGreater(UsagerRole.EXECUTIVE_LIMITED_ADMIN);
    }

  isGreaterThan_EXECUTIVE_LIMITED_ADMIN(): boolean{
    return this.isRoleGreater(UsagerRole.EXECUTIVE_LIMITED_ADMIN);
  }

  isSameOrLessThan_USER_REPONSABLE():boolean{
      return this.isRoleSameOrLess(UsagerRole.USER_REPONSABLE);
  }


  isRESPONSABLE(): boolean{
    return this.isRoleSame(UsagerRole.USER_REPONSABLE);
  }

  isGreaterThanRESPONSABLE(): boolean{
     return this.isRoleGreater(UsagerRole.USER_REPONSABLE);
   }

  isGreaterThanREAD_ONLY_LIMITED_REPONSABLE(): boolean{
    return this.isRoleGreater(UsagerRole.READ_ONLY_LIMITED_REPONSABLE);
  }


  isREAD_ONLY_LIMITED_REPONSABLE(): boolean{
    return this.isRoleSame(UsagerRole.READ_ONLY_LIMITED_REPONSABLE);
  }

  isSysAdmin():boolean{
      return this.isRoleSame(UsagerRole.SYS_ADMIN);
    }


  isAdmin(){
    return this.isRoleSameOrGreater(UsagerRole.ADMIN);
  }



    public set hideAmountTemporary(b:boolean){
      this._hideAmountTemporary = b;
    }


    public get hideAmountTemporary() : boolean{
      return this._hideAmountTemporary;
    }

  public set hideAMPMTemporary(b:boolean){
    this._hideAMPMTemporary = b;
  }


  public get hideAMPMTemporary() : boolean{
    return this._hideAMPMTemporary;
  }



  canSeeAmount() :boolean{
      if (this._hideAmountTemporary){
        return false;
      }
      if (this.isSysAdmin()){
        return true;
      }
      // if (this.isRoleSame(UsagerRole.USER_REPONSABLE)){
      //   return true;
      // }
      if (this.isRoleSame(UsagerRole.EXECUTIVE_LIMITED_ADMIN)){
        return true;
      }
      if (this.isRoleSame(UsagerRole.ADMIN)){
        return true;
      }
      return false;
    }

  get canModifyJob(): boolean{
      if (this.isSysAdmin()){
        return true;
      }
      if (this.userInfo) {
        if (this.userInfo.user) {
          if (this.userInfo.user.canModifyJob){
            return true;
          }
        }
      }
      return false;
  }



  get canManageOtherBudget() :boolean{
      // return true;
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {
      if (this.userInfo.user) {
        if (this.userInfo.user.canManageOtherBudget){
          return true;
        }
      }
    }
    return false;
  }


  get canManageEvent() :boolean{
      // return true;
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {
      if (this.userInfo.user) {
        if (this.userInfo.user.canManageDateEvent){
          return true;
        }
      }
    }
    return false;
  }

  get canManageSalesCostObjective() :boolean{
      //return true;

      if (this.isSysAdmin()){
    return true;
  }
  if (this.userInfo) {
    if (this.userInfo.user) {
      if (this.userInfo.user.canManageSalesCostObjective){
        return true;
      }
    }
  }
  return false;

  }


  get canManageGeoFence() :boolean{
    //return true;

    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {
      if (this.userInfo.user) {
        if (this.userInfo.user.canManageGeoFence){
          return true;
        }
      }
    }
    return false;

  }


  get canManageBanks() :boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canManageBankType){
          return true;
        }
      }
    }
    return false;
  }

  get canLockTimesheet() :boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canLockTimesheet){
          return true;
        }
      }
    }
    return false;
  }


  get canUnlockAllTimesheet() :boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canUnlockAllTimesheet){
          return true;
        }
      }
    }
    return false;
  }


  get canManageExpenseType() :boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canManageExpenseType){
          return true;
        }
      }
    }
    return false;
  }


  get canManageEvaluation() :boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canManageEvaluation){
          return true;
        }
      }
    }
    return false;
  }


  canModifyStructure():boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canModifyStructure){
          return true;
        }
      }
    }
    return false;

  }


  get canLockExpense() :boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canLockTimesheet){
          return true;
        }
      }
    }
    return false;
  }


  get canUnlockAllExpense() :boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canUnlockAllTimesheet){
          return true;
        }
      }
    }
    return false;
  }


  get canSendMemoToSameLevelUser() :boolean{
    if (this.isSysAdmin()){
      return true;
    }
    if (this.userInfo) {

      if (this.userInfo.user) {
        if (this.userInfo.user.canSendMemoToSameLevelUser){
          return true;
        }
      }
    }
    return false;
  }

  public dayType(dayIndex: number): DayType{
    const weekStart = this.userInfo.weekStart.momentCode;
    // console.log('weekStart: ' + weekStart );
    let dayOfWeek = weekStart + dayIndex;
    // console.log('dayOfWeek: ' + dayOfWeek % 7);
    dayOfWeek = dayOfWeek % 7;
    switch (dayOfWeek) {
      case 0:
        return DayType.SUNDAY;
      case 1:
        return DayType.MONDAY;
      case 2:
        return DayType.TUESDAY;
      case 3:
        return DayType.WEDNESDAY;
      case 4:
        return DayType.THURSDAY;
      case 5:
        return DayType.FRIDAY;
      case 6:
        return DayType.SATURDAY;
    }

    return null;
  }

//    localStorage.removeItem('currentUser');


}
